// 검사 진행 상황(localStorage) 자동 저장/복원을 위한 공통 유틸.
// 각 검사는 고유한 키를 사용하며, 값은 JSON 문자열로 직렬화해 저장한다.

export const TEST_PROGRESS_KEYS = {
  iq: 'mc-test-iq',
  studyStyle: 'mc-test-study-style',
  careerPage: 'mc-test-career-page',
  careerHolland: 'mc-test-career-holland',
  careerValue: 'mc-test-career-value',
  literacyPage: 'mc-test-literacy-page',
  literacyVocab: 'mc-test-literacy-vocab',
  literacyReading: 'mc-test-literacy-reading',
  english: 'mc-test-english',
} as const;

export interface SectionProgress {
  current: number;
  answers: Record<string, number>;
}

export function readProgress<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function writeProgress(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // 저장 실패는 치명적이지 않으므로 조용히 무시한다.
  }
}

export function clearProgress(...keys: string[]): void {
  keys.forEach((k) => {
    try {
      localStorage.removeItem(k);
    } catch {
      // 무시
    }
  });
}